// @flow
import { combineReducers } from 'redux';
import scribeConversation from './scribeConversation';
import scribeSession from './scribeSession';
import scribeTranscriptUI from './scribeTranscriptUI';
import firebase from './firebase';
import scribeNotifications from './scribeNotifications';
import scribeTrainings from './scribeTrainings';
import scribeDashboard from './scribe-dashboard';

// $FlowFixMe
const rootReducer = combineReducers({
  scribeConversation,
  scribeSession,
  scribeTranscriptUI,
  firebase,
  scribeNotifications,
  scribeTrainings,
  scribeDashboard,
});

export default rootReducer;
